import { AttachIcon } from '@/app/icons/AttachIcon';
import { Button, ButtonProps, CircularProgress } from '@mui/material';
import { Theme } from '@mui/material/styles';
import React, { FC, PropsWithChildren, ReactElement } from 'react';

export interface AttachButtonProps extends ButtonProps {
  isLoading?: boolean;
  /** How badly the attachment fared, which the button draws in orange or in red. */
  severity?: 'warning' | 'error';
}

type Props = PropsWithChildren<AttachButtonProps>;

export const AttachButton: FC<Props> = (props: Props): ReactElement => {
  const { isLoading, severity, children, ...other } = props;

  const severityColor = (theme: Theme): string | undefined => {
    if (severity === 'error') {
      return theme.colors.red;
    }
    if (severity === 'warning') {
      return theme.colors.orange;
    }
    return undefined;
  };

  return (
    <Button
      variant={'outlined'}
      color={'inherit'}
      sx={{
        display: 'flex',
        color: (theme: Theme) => severityColor(theme) || theme.colors.grayText,
        width: (theme: Theme) => theme.spacing(3),
        height: (theme: Theme) => theme.spacing(2.5),
        minWidth: 'auto',
        border: (theme: Theme): string => '1px solid ' + (severityColor(theme) || theme.colors.borderColor),
        borderRadius: (theme: Theme) => theme.spacing(0.5),
        padding: 0,
      }}
      {...other}>
      {isLoading ? (
        <CircularProgress size={12} />
      ) : children ? (
        children
      ) : (
        <AttachIcon
          sx={{
            width: (theme: Theme) => theme.spacing(2),
            height: (theme: Theme) => theme.spacing(2),
            transform: 'rotate(45deg)',
          }}
        />
      )}
    </Button>
  );
};
